import type { AnalyticsProvider } from '~analytics/types/analyticsProvider';
import type { RuntimeConfig } from 'nuxt/schema';

interface HotjarApi {
  hj: (operationType: string, eventName: string) => void;
}
export default class HotjarProvider implements AnalyticsProvider {
  serviceName: string;
  subscribedEvents: string[];
  hotjar?: HotjarApi;

  constructor(
    serviceName: string,
    config: RuntimeConfig,
    subscribedEvents: string[],
  ) {
    this.serviceName = serviceName;
    this.subscribedEvents = subscribedEvents;
  }

  async init() {
    this.hotjar = useScriptHotjar() as unknown as HotjarApi;
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  track(eventName: string, eventData?: object) {
    this.hotjar?.hj('event', eventName);
  }

  identify(guid?: string) {
    if (!guid) {
      throw new Error('guid is required');
    }

    this.hotjar?.hj('identify', guid);
  }

  reset() {
    // noop atm
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  setUserProperties(properties: Record<string, unknown>) {
    // noop atm
  }

  getSubscribedEvents() {
    return this.subscribedEvents;
  }
}
